// @flow
import React from 'react';
// eslint-disable-next-line import/named
import { FormattedMessage, type IntlShape } from 'react-intl';

// Constants
import { TRANSPORTATION, TRANSPORTATION_LABEL } from 'constants/transportation';

// Components
import { Col, Row } from 'reactstrap';
import Alert from 'components/atoms/Alert';

const ns = 'unavailable-banner';

export type Props = {
  transpOptionInfo: Object,
  transportOptions: Array<Object>,
  isTransportationAvailable: (transportation?: string) => Boolean,
  intl: IntlShape
};

const {
  DROPOFF,
  WAITER,
  SHUTTLE,
  RENTAL,
  VALET,
  LOANER,
  RIDESHARE
} = TRANSPORTATION;
const {
  DROPOFF_LABEL,
  WAITER_LABEL,
  SHUTTLE_LABEL,
  RENTAL_LABEL,
  VALET_LABEL,
  LOANER_LABEL,
  RIDESHARE_LABEL
} = TRANSPORTATION_LABEL;

const setLabelTransportation = (data: string) => {
  switch (data) {
    case DROPOFF:
      return DROPOFF_LABEL;
    case WAITER:
      return WAITER_LABEL;
    case SHUTTLE:
      return SHUTTLE_LABEL;
    case LOANER:
      return LOANER_LABEL;
    case RENTAL:
      return RENTAL_LABEL;
    case VALET:
      return VALET_LABEL;
    case RIDESHARE:
      return RIDESHARE_LABEL;
    default:
      return false;
  }
};

const UnavailableBanner = ({
  transpOptionInfo,
  transportOptions,
  isTransportationAvailable
}: Props) => {
  if (
    transportOptions.length === 0 ||
    !transpOptionInfo ||
    isTransportationAvailable(transpOptionInfo.data)
  ) {
    return null;
  }

  return (
    <Row className={`${ns}__row`}>
      <Col xs={12}>
        <Alert color="danger">
          <FormattedMessage
            id="c8.drop.off.is.no.longer.available"
            values={{
              transportationOption: (
                <strong>{setLabelTransportation(transpOptionInfo.data)}</strong>
              )
            }}
          />
        </Alert>
      </Col>
    </Row>
  );
};

export default UnavailableBanner;



// WEBPACK FOOTER //
// ./src/components/atoms/UnavailableBanner/UnavailableBanner.js